<app-page>
  <not-found></not-found>
</app-page>
